import { useQuery } from '@tanstack/react-query';
import { get } from '../api';
import type { Group } from '../types';

/** Grupos visibles (todos para superadmin, el propio para el resto). */
export function useGroups(enabled = true) {
  return useQuery({
    queryKey: ['groups'],
    queryFn: async () => (await get<{ items: Group[] }>('/groups')).items,
    enabled,
    staleTime: 60_000,
  });
}

export function groupName(groups: Group[] | undefined, id: number | null) {
  if (id === null) return '—';
  return groups?.find((g) => g.id === id)?.name ?? `#${id}`;
}
